import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { EditProfilePhotoComponent } from './edit-profile-photo.component';
import { SharedModule } from '../../../../shared/shared.module';
import { ProfilePhotoModule } from '../profile-photo.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    ProfilePhotoModule,
  ],
  declarations: [EditProfilePhotoComponent],
  exports: [EditProfilePhotoComponent],
})
export class EditProfilePhotoModule {}
